import React from 'react'
import "./categories.css"

function Categories({data}) {
  return (
    <div className='category-container'>
        {data.map((item, index) => 
            <div key={index} className='category-info'>
                <img className="category-image" src={item.imageUrl} alt='' />
                <h3>{item.title}</h3>
            </div>
        )}
    </div>
  )
}

export default Categories